var map = {
	"./arrow_icon.png": 1359,
	"./float_bc.png": 5434,
	"./float_bc_active.png": 6617,
	"./junpintan.png": 2549,
	"./light.png": 2312,
	"./logo.png": 1123,
	"./next.png": 7777,
	"./next2.png": 3543,
	"./page_2_bc.png": 5168,
	"./page_3_bc.png": 9075,
	"./page_3_swiper_bc.png": 3474,
	"./page_4_bc.png": 5606,
	"./people_after.png": 1460,
	"./people_before.png": 4437,
	"./play.png": 1860,
	"./play_main.png": 8462,
	"./play_white.png": 5970,
	"./prev.png": 245,
	"./prev2.png": 1827,
	"./xi_image.png": 7057,
	"./xi_text.png": 1077
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9415;